import React from "react";
import { SectionContainerWrapper } from "modules/shared/components/SectionContainer/SectionContainer.components";
import { FunctionComponent } from "react";

const SectionContainer: FunctionComponent = ({ children }) => {
  return <SectionContainerWrapper>{children}</SectionContainerWrapper>;
};

export default SectionContainer;
